import { ORDER_METHODS } from '../../../../../services/exports/Constants';
import { ValidationErrors } from '../../../../../modals/order-method/types';

export default {
  title: 'Valitse sijainti',
  order_methods: {
    [ORDER_METHODS.ON_SITE]: 'Pöytätilaus',
    [ORDER_METHODS.PICKUP]: 'Nouto',
    [ORDER_METHODS.DELIVERY]: 'Toimitus',
  },
  text_inputs: {
    address: {
      placeholder: 'Hae osoitettasi',
    },
    street_name: {
      placeholder: 'Katu',
    },
    street_number: {
      placeholder: 'Talon numero',
    },
    city: {
      placeholder: 'Kaupunki',
    },
    zip: {
      placeholder: 'Postinumero',
    },
  },
  time_options: {
    asap: {
      title: 'Vakio',
      description: 'Valmis {{time}} min kuluttua',
    },
    scheduled: {
      title: 'Aikatauluta myöhemmäksi',
    },
  },
  time_drop_down: {
    today: 'Tänään',
  },

  pickup: {
    address: 'Nouto-osoite',
    when: 'Milloin?',
  },

  delivery: {
    where: 'Minne?',
    when: 'Milloin?',
    address: 'Osoitteesi',
    delivery_area: 'Toimitusalueemme',
  },

  buttons: {
    view_menu: 'Näytä ruokalista',
    see_hours: 'Katso aukioloajat',
    next: 'Seuraava',
    change: 'Muuta',
    save: 'Tallenna',
  },

  labels: {
    when: 'Milloin?',
    pickup: 'Verkkonouto',
    delivery: 'Toimitus',
    pickup_time: 'noutoaika',
    delivery_time: 'toimitusaika',
    discount: 'Vain täällä {{value}} verkkoalennus',
    pre_orders_enabled: 'Toistaiseksi voit tehdä ajastetun tilauksen myöhemmäksi',
    change_location: '← Palaa ruokalistaan, jos haluat valita toisen sijainnin',
    return: 'Palaa',
  },

  items_dropped: {
    count_one: '{{count}} tuote poistettu',
    count_other: '{{count}} tuotetta poistettu',
    pickup_reason: '— ei saatavilla noutoon.',
    delivery_reason: '— ei saatavilla toimitukseen.',
  },

  error_messages: {
    [ValidationErrors.address_not_found]:
      'Valitettavasti emme löytäneet kyseistä osoitetta. Yritä uudelleen syöttämällä ensin katu osoitteen hakukenttään.',
    [ValidationErrors.address_not_serviceable]:
      'Osoitteesi on toimitusalueemme ulkopuolella. Haluaisitko vaihtaa osoitetta vai siirtyä noutotilaukseen? 😊',
    [ValidationErrors.no_drivers_available]:
      'Valitettavasti emme voi toimittaa tällä hetkellä. Haluaisitko tilata noudettavaksi? 😊',
    pickup_unavailable: 'Valitamme, emme tällä hetkellä tarjoa noutoa.',
    delivery_unavailable: 'Valitamme, emme tällä hetkellä tarjoa toimitusta.',
    delivery_paused: 'Valitamme, emme tällä hetkellä tarjoa toimitusta.',
    outside_pickup_times: 'Emme tarjoa noutoa tällä hetkellä. Noutoaikamme:',
    outside_delivery_times: 'Emme tarjoa toimitusta tällä hetkellä. Toimitusaikamme:',
    orders_paused_inactivity:
      'Suuren kysynnän vuoksi emme pysty ottamaan vastaan enempää verkkotilauksia juuri nyt. Tilaa paikan päällä tai yritä uudelleen 30 minuutin kuluttua.',
    orders_paused_manual_end_of_day: 'Valitettavasti olemme suljettu loppupäiväksi.',
    orders_paused_manual_until_time:
      'Suuren kysynnän vuoksi emme pysty ottamaan vastaan enempää verkkotilauksia juuri nyt. Tilaa paikan päällä tai yritä uudelleen alkaen {{pausedUntil}}',
    company_closed: 'Valitettavasti emme ole avoinna tällä hetkellä.',
    pickup_closed:
      'Otamme noutotilauksia vastaan {{time}} asti, koska valmistusaikamme on {{preparationTime}} minuuttia.',
    delivery_closed:
      'Otamme toimitustilauksia vastaan {{time}} asti, koska toimitusaikamme on {{preparationTime}} minuuttia.',
    live_orders_off:
      'Valitettavasti emme voi tällä hetkellä ottaa vastaan enempää verkkotilauksia. Kiitos ymmärryksestäsi.',
    orders_unavailable:
      '{{type}} ei ole saatavilla tällä hetkellä. Seuraava mahdollinen {{typeTime}} on {{day}} {{time}}.',
  },

  no_couriers: {
    with_code:
      'Valitettavasti meillä ei ole juuri nyt vapaita kuljettajia. Yritä myöhemmin uudelleen tai tilaa noutona ja käytä alennuskoodia <PromoCode>{{code}}</PromoCode> kassalla.',
    without_code:
      'Valitettavasti meillä ei ole juuri nyt vapaita kuljettajia. Yritä myöhemmin uudelleen tai tilaa noutona.',
    copied: 'Alennuskoodi kopioitu',
  },
};
